import React from 'react';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from '@/components/ui/buttons';
import { Text } from '@/components/ui/text';
import { IconScout } from '@/components/ui/images/IconScout';
import { colors } from '@/assets/styles/colors';


interface SSOLinkSuccessFormProps {
  onRedirect: () => void;
}

export const SSOLinkSuccessForm: React.FC<SSOLinkSuccessFormProps> = ({ onRedirect }) => {
  const { t: translate } = useTranslation();

  return (
    <div className="flex flex-col items-center text-center space-y-6">
      <div
        className="flex items-center justify-center w-16 h-16 rounded-full"
      >
        <IconScout name="checkCircle" size="xl" color={colors.feedback.success400} />
      </div>

      <Text variant="body-regular" color={colors.grays.neutral66}>
        {translate('auth:ssoLinking.success.message')}
      </Text>

      <div className="w-full pt-2">
        <PrimaryButton
          colorVariant="success"
          fullWidth
          iconRight={<IconScout name="externalLink" size="md" />}
          onClick={onRedirect}
        >
          {translate('auth:ssoLinking.success.redirect')}
        </PrimaryButton>
      </div>
    </div>
  );
};
